// Port of api/fuel/app/classes/filter/search/games/filters/query/game/version/size/width.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'version.size.width',
	priority: 65,
	require: function(config, filter) { return filter.version && filter.version.size && rangeActive(filter.version.size.width, 0, 9999) },
	run: function(config, filter, data, query) {
		if (filter.version.size.width.from > 0) query.where('v.game_version_storage_width', '>=', filter.version.size.width.from)
		if (filter.version.size.width.to < 9999) query.where('v.game_version_storage_width', '<=', filter.version.size.width.to)
	}
}
